import { SET_ART_WALL_PRODUCT_FEED } from './../const';

export default (artWallProductFeed) => {
  return {
    type: SET_ART_WALL_PRODUCT_FEED,
    artWallProductFeed: artWallProductFeed
  }
};
